import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type CasterNodeOptions = {} & SimpleManaNodeOptions

export default class TargetCasterNode extends SimpleManaNode {

	static nodeName = "Target Caster"
	static nodeDesc = "Targets the caster of this spell"
	static nodeIcon = '🧙‍♂️'
	static category = NodeCategories.Targeting
	static nodeType = 'TargetCaseterNode'

	onScroll(dir: number) { }

	async act(particle: ManaParticle) {

		particle.setTarget(particle.caster)

		return true
	}

	getSymbol() {
		return TargetCasterNode.nodeIcon.substring(0, 2)
	}

}